import { Popover } from '@base-ui/react';
import cx from 'classnames';
import { useRef } from 'react';
import { Calendar } from '@components/calendar/Calendar';
import { Icon } from '@components/icon/Icon';
import { useIsOpen } from '@shared/hooks/useIsOpen';
import { toShortWeekDateFormat } from '@shared/utils/dateFormatters';
import typography from '~styles/typography.scss';
import styles from './DatePicker.scss';

interface DatePickerProps {
  selectedDate: Date;
  handleOnChangeCalendarDate: (date: Date) => void;
  handleOnClickNextDay: () => void;
  handleOnClickPrevDay: () => void;
}

export const DatePicker = ({
  selectedDate,
  handleOnChangeCalendarDate,
  handleOnClickNextDay,
  handleOnClickPrevDay,
}: DatePickerProps) => {
  const { isOpen, close, open } = useIsOpen();

  return (
    <Popover.Root
      open={isOpen}
      onOpenChange={(_open) => {
        if (!_open) close();
      }}
    >
      <div className={styles.buttonContainer}>
        <button
          type="button"
          aria-label="Previous"
          className={styles.chevronLeft}
          onClick={handleOnClickPrevDay}
        >
          <Icon name="chevronLeft" />
        </button>

        <Popover.Trigger
          className={cx(typography.h6m_20, styles.selectedDate)}
          aria-label="Choose date"
          onClick={open}
        >
          {toShortWeekDateFormat(selectedDate)}
        </Popover.Trigger>

        <button
          type="button"
          aria-label="Next"
          className={styles.chevronRight}
          onClick={handleOnClickNextDay}
        >
          <Icon name="chevronRight" />
        </button>
      </div>
      <Popover.Portal>
        <Popover.Positioner
          align="start"
          side="bottom"
          className={styles.positioner}
        >
          <Popover.Popup
            className={styles.calendarPopover}
            // Disable initial focus on the first focusable element by passing a
            // null ref.
            initialFocus={useRef(null)}
          >
            <Calendar
              value={selectedDate}
              onDateChange={(value) => {
                handleOnChangeCalendarDate(value);
                close();
              }}
            />
          </Popover.Popup>
        </Popover.Positioner>
      </Popover.Portal>
    </Popover.Root>
  );
};
